import Footer from "../components/FooterComponents/Footer";
import SEO from "../components/SEO";
import { seoConfig } from "../data/seoConfig";
import { useEffect } from "react";

const Home = () =>{
    
     useEffect(() => {
    const btn = document.querySelector('.scroll-top');
    if (btn) {
      const handleClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });
      btn.addEventListener('click', handleClick);

      // cleanup (important)
      return () => btn.removeEventListener('click', handleClick);
    }
  }, []);
    return(
        <>
        <SEO {...seoConfig.home} />
        <div id="home" className="hero-section">     
      <div className="container">
        <div className="row align-items-center">
            <div className="hero-content mt-5">
							<h1>Building success using creative and impactful digital experiences.</h1>
							<p className="mt-4">We are a software development company specializing in delivering custom software solutions tailored to the unique requirements of businesses across all sizes and industries.</p>
            </div>
					</div>
        </div>
    </div>
    <div className="container mt-0 mt-md-5 ">
            <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5 mt-md-5 mt-sm-5 mt-xs-5">
                   <h1 className="text-grey fw-bolder">
                        Built for Tomorrow
                    </h1>
                    <p className="text-grey  fw-bold mt-4">
                         Our team of experienced and skilled developers is dedicated to crafting high-quality, reliable software that drives efficiency, innovation, and growth for our clients.
                     </p>
                     <ul className="mt-4 ms-3">
                        <li className="mt-3">Frontend Development</li>
                        <li className="mt-2">Backend Development</li>
                        <li className="mt-2">Mobile App Development</li>
                        <li className="mt-2">Web Design</li>
                        <li className="mt-2">Custom Software Development</li>
                     </ul>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                    <img 
                    src="/assets/images/hero/home-img.jpg"
                        className="img-fluid w-100 rounded page-section-image"
                        alt="Home"
                        fetchPriority="high"
                        loading="eager"/>
                </div>
            </div>
        </div>
        <div className="container-fluid mt-5 pt-3 px-3 px-md-5">
          <h2 className="text-center pb-3 text-grey fw-bolder">Our Path to Project Success</h2>

          <div className="row g-4 mt-2">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="bg-light p-3 h-100 home-div rounded text-center">
                <img src="/assets/images/hero/i1.png" className="image-home mx-auto d-block" loading="lazy" />
                <h4 className="pt-3">Exploring & Evaluating</h4>
                <p className="home-p p-3">
                  At this stage, we explore your objectives and challenges for a successful path forward.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="bg-light p-3 h-100 home-div rounded text-center">
                <img src="/assets/images/hero/i2.png" className="image-home mx-auto d-block" loading="lazy" />
                <h4 className="pt-3">Blueprint & Vision</h4>
                <p className="home-p p-3">
                  Using the findings from the discovery phase, we craft a detailed plan for your digital build.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="bg-light p-3 h-100 home-div rounded text-center">
                <img src="/assets/images/hero/i3.png" className="image-home mx-auto d-block" loading="lazy" />
                <h4 className="pt-3">Bringing Projects to Life</h4>
                <p className="home-p p-3">
                  With the foundation ready, we bring your concept to life as an interactive digital experience.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="bg-light p-3 h-100 home-div rounded text-center">
                <img src="/assets/images/hero/i4.png" className="image-home mx-auto d-block" loading="lazy" />
                <h4 className="pt-3">Go Live and Assistance</h4>
                <p className="home-p p-3">
                  From go-live onward, we ensure your success every step of the way.
                </p>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        </>
    )
}
export default Home;